<template>
  <div class="w-100 h-100 position-relative">
    <div class="vd-VendorsMap_DeliveryZoneHeader">{{ t.delivery_zone_header }}</div>
    <div v-if="activeVendor.id" class="vd-VendorsMap_SelectedVendorWrapper">
      <slot></slot>
    </div>
    <GoogleMap ref="mapRef" :zoom="zoom" :center="center" @map-loaded="afterLoadMap">
      <template slot-scope="{ map }">
        <GoogleMapMarker
          v-for="vendor in mapData"
          :key="`marker-${vendor.id}`"
          :ref="`marker-${vendor.id}`"
          :icon="{
            url: vendor.id === activeVendor.id ? MarkerIconActive : MarkerIcon,
            size: new google.maps.Size(50, 60),
            scaledSize: new google.maps.Size(50, 60),
          }"
          :style="vendor.id === activeVendor.id ? 'pointer-events: none;' : ''"
          :title="vendor.name"
          :google="google"
          :map="map"
          :position="{ lat: vendor.lat, lng: vendor.lng }"
          :clickable="true"
          :z-index="vendor.id === activeVendor.id ? 100 : 0"
          @click="selectVendor(vendor)"
          @initiate="setMarker"
        />
        <GoogleMapPolygon
          v-for="(path, index) in paths"
          :key="index"
          :path="path"
          :google="google"
          :map="map"
        />
        <GoogleMapCluster
          v-if="markers.length == mapData.length"
          :map="map"
          :markers="markers"
          :google="google"
          :clusterPath="clusterPath"
        />
      </template>
    </GoogleMap>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import GoogleMap from "./GoogleMap";
import GoogleMapMarker from "./GoogleMapMarker";
import GoogleMapPolygon from "./GoogleMapPolygon";
import GoogleMapCluster from "./GoogleMapCluster";
import MarkerIcon from "@assets/images/static/marker/map-pin.png";
import MarkerIconActive from "@assets/images/static/marker/map-pin-active.png";

export default {
  name: "StoreVendorsMap",
  components: {
    GoogleMap,
    GoogleMapMarker,
    GoogleMapPolygon,
    GoogleMapCluster,
  },
  props: {
    mapData: {
      type: Array,
      required: true,
    },
    cityZone: {
      type: Object,
      default: undefined,
    },
    clusterPath: {
      type: String,
      required: true,
    },
    t: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      paths: [],
      center: {
        lat: this.mapData[0].lat,
        lng: this.mapData[0].lng,
      },
      zoom: 14,
      query: "",
      iconOffset: undefined,
      google: null,
      markers: [],
      MarkerIcon,
      MarkerIconActive,
    };
  },
  computed: {
    ...mapGetters({
      activeVendor: "vendorsIndex/activeVendor",
    }),
  },
  watch: {
    activeVendor(vendor) {
      this.zoom = 18;
      this.$refs.mapRef.map.panTo({ lat: vendor.lat, lng: vendor.lng });
    },
  },
  methods: {
    ...mapActions({
      setActiveVendor: "vendorsIndex/setActiveVendor",
    }),
    setMarker(marker) {
      this.markers.push(marker);
    },
    afterLoadMap() {
      this.google = this.$refs.mapRef.google;
      this.createDeliveryAreas();
    },
    createDeliveryAreas() {
      this.bounds = new this.google.maps.LatLngBounds();
      if (this.cityZone?.delivery_areas) {
        this.paths = this.cityZone.delivery_areas.map(deliveryArea => {
          let mappedArea = deliveryArea[0].map(points => {
            let latlng = {
              lat: points[1],
              lng: points[0],
            };
            this.bounds.extend(latlng);
            return latlng;
          });
          return mappedArea;
        });
      }
      this.mapData.map(vendor => {
        this.bounds.extend({
          lat: vendor.lat,
          lng: vendor.lng,
        });
      });
      this.$refs.mapRef.map.fitBounds(this.bounds);
    },
    selectVendor(vendor) {
      this.setActiveVendor(vendor);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.vd-VendorsMap_DeliveryZoneHeader {
  @include header-font-bold;
  position: absolute;
  z-index: $zi-highest;
  top: $spacer-1;
  left: $spacer-1;
  display: flex;
  padding: $spacer-1;
  text-transform: uppercase;
  color: $body-color;
  background: $white;
  font-size: $font-size-xs;
  border-radius: $border-radius-sm;

  &::before {
    display: block;
    width: $spacer-2;
    height: $spacer-2;
    margin-right: $spacer-1;
    content: "";
    border: $width-border-thin solid $gray-300;
    border-radius: $border-radius-sm;
    background: rgba($primary, $opacity-near-visible);
  }
}

.vd-VendorsMap_SelectedVendorWrapper {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  z-index: $zi-high;
  pointer-events: none;
  padding: $spacer-3;
}
</style>
